import React,{ useState, useEffect } from "react";
import Carousel from 'react-multi-carousel';
import FlipButtonComponent from './FlipButton';
import './CorauselSlider.css';

// Corausel component
const CustomButtonGroup = ({ next, previous, progressPercentage, showProgressBar = true }) => {
    return (
        <div className='progress-button-container'>
            {showProgressBar && 
            <div className='progress-bar-container'>
                <div className='progress-bar' style={{ width: `${progressPercentage}%`}}/>
            </div>}
            
            <FlipButtonComponent onClickLeft={previous} onClickRight={next}> </FlipButtonComponent>
        </div>
    );
};

const BREAKPOINT_DESKTOP = 1300;
const BREAKPOINT_TABLET = 900;
const BREAKPOINT_MOBILE = 0;

const defaultResponsive = {
    desktop: {
        breakpoint: { max: 3000, min: BREAKPOINT_DESKTOP },
        items: 3,
    },
    tablet: {
        breakpoint: { max: BREAKPOINT_DESKTOP, min: BREAKPOINT_TABLET },
        items: 2,
    },
    mobile: {
        breakpoint: { max: BREAKPOINT_TABLET, min: BREAKPOINT_MOBILE },
        items: 1,
    }
};

/**
    * CorauselSlider component
    * @param {Array} cards - Array of cards to be displayed in the slider
    * @param {Function} renderCard - Function to render each card
    * @param {string} containerClassCss - CSS class for the container
    * @param {string} sliderClassCss - CSS class for the slider
    * @param {string} itemClassCss - CSS class for the items
    * @returns {JSX.Element} The rendered CorauselSlider component
*/
const CorauselSlider = ({ cards,  renderCard, responsive = defaultResponsive, containerClassCss, sliderClassCss, itemClassCss, showProgressBar }) => {

    const [currentSlide, setCurrentSlide] = useState(0);
    
        // Corausel component
        const [currentBreakpoint, setCurrentBreakpoint] = useState('desktop');
        
        const handleBeforeChange = (nextSlide) => {
    
            const progressPercentage = calculateProgressPercentage(nextSlide, cards.length);
            setProgressPercentage(progressPercentage);
        };
    
        const handleAfterChange = (previousSlide, { currentSlide }) => {
    
            setCurrentSlide(currentSlide);
        };
    
        const calculateProgressPercentage = (currentSlide, totalSlides) => {
    
            let responsiveItems = responsive[currentBreakpoint].items;
            return ((currentSlide + responsiveItems) / totalSlides) * 100;
        }
    
        const [progressPercentage, setProgressPercentage] = useState(calculateProgressPercentage(currentSlide, cards.length));
    
        // Function to update current breakpoint
        const updateCurrentBreakpoint = () => {
    
            const width = window.innerWidth;
    
            if (width >= BREAKPOINT_DESKTOP) {
                setCurrentBreakpoint('desktop');
            } else if (width >= BREAKPOINT_TABLET) {
                setCurrentBreakpoint('tablet');
            } else {
                setCurrentBreakpoint('mobile');
            }
        };
       
        // Update breakpoint on resize
        useEffect(() => {
            const handleResize = () => {
                updateCurrentBreakpoint();
            };
    
            window.addEventListener('resize', handleResize);
    
            updateCurrentBreakpoint(); // Initial breakpoint update
    
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }, []);
    
        // Update progress percentage on current slide change
        useEffect(() => {
            const progressPercentage = calculateProgressPercentage(currentSlide, cards.length, currentBreakpoint);
            setProgressPercentage(progressPercentage);
        }, [currentSlide, cards.length, currentBreakpoint]); // 当currentSlide, cards.length, currentBreakpoint发生变化时，重新计算progressPercentage

    return (
        <Carousel 
            arrows={false} 
            responsive={responsive} 
            renderButtonGroupOutside={true} 
            customButtonGroup={<CustomButtonGroup 
                progressPercentage={progressPercentage} 
                showProgressBar={showProgressBar} />}
            beforeChange={handleBeforeChange}
            afterChange={handleAfterChange}
            containerClass={containerClassCss}
            sliderClass={sliderClassCss}
            itemClass={itemClassCss}
        >
    
        {cards.map((card) => renderCard(card))}

        </Carousel>
    );
};

export default CorauselSlider;